export const discount = {
    header: 'Sie haben einen Gutscheincode?',
    usedVoucher: 'Eingelöster Gutschein',
    inputLabels: {
        discountCode: 'Gutscheincode',
    },
    voucherIsValid: 'Gutschein gültig!',
    voucherIsNotValid: 'Gutschein ungültig.',
    couldNotBeValidated: 'Dieser Gutscheincode ist leider nicht gültig. <br/>',
    loginRequired: 'Anmeldung notwendig',
    voucherNeedsLogin:
        'Der eingegebene Gutschein-Code ist nur für registrierte Kunden einlösbar.<br/><br/>Bitte melden Sie sich an oder registrieren Sie sich.<br/>',
    voucherMaxUsageReached: 'Die maximale Anzahl an Nutzungen für den eingegeben Gutschein-Code wurden erreicht.',
    relativeDiscount:
        'Mit diesem Gutschein erhalten Sie <span class="has-text-primary-dark">{value}%</span> Rabatt.',
    absoluteDiscount:
        'Mit diesem Gutschein werden Ihnen <span class="has-text-primary-dark">{value}€</span> am Ende Ihrer Bestellung abgezogen.',
    absoluteDiscountBusinessCustomers:
        'Mit diesem Gutschein werden Ihnen <span class="has-text-primary-dark">{value}€</span> netto am Ende Ihrer Bestellung abgezogen.',
    applicableXTimes:
        'Dieser Gutschein ist gar nicht Einlösbar. | Sie können diesen Gutscheincode nur einmal verwenden. | Sie können diesen Gutschein nur {n} mal verwenden.',
    minimumOrderTotal:
        'Dieser Gutschein ist nur für Bestellungen über einen Betrag von mindestens <span class="has-text-primary">{amount}€</span> gültig.',
    orderGoal:
        'Sie benötigen noch <span class="has-text-danger">{amount} €</span> um diesen Gutsschein einzulösen.',
    belowMinimumOrderTotal: 'Mindestbestellwert nicht erreicht',
    freeShipping: 'Wir versenden Ihre Ware kostenlos mit dem Standard Versand.',
    actionLabels: {
        validateCode: 'Prüfen',
        cancel: 'Abbrechen',
        redeemDiscount: 'Gutschein Einlösen',
        continueShopping: 'Weiter Einkaufen',
        tryAgain: 'Zurück',
        removeDiscount: "Entfernen",
    },
};
